document.addEventListener("DOMContentLoaded", () => {
    const makeSelects = document.querySelectorAll('select:where([name*="[vehicle_make_id]"], [name*="[vehicle_vehicle_make_id]"])')
    const namespace = document.querySelector('body').getAttribute('namespace')
    if (makeSelects.length === 0 || !namespace) return

    const selectPromptContent = () => {
        return document.querySelector('meta[name="localized-select-prompt"]').getAttribute("content")
    }

    const resetModelOptions = modelSelect => {
        modelSelect.innerHTML = createElement("option", {value: "", textContent: selectPromptContent()}).outerHTML
        modelSelect.disabled = true
    }

    const updateModelOptions = async (makeSelect) => {
        const modelSelect = makeSelect.closest("fieldset.inputs")?.querySelector('select:where([name*="[make_model_id]"], [name*="[vehicle_make_model_id]"])')
        if (!modelSelect) return

        resetModelOptions(modelSelect)

        const makeId = makeSelect.value
        if (!makeId) return

        const path = `/${namespace}/vehicle_makes/${makeId}/make_models`

        try {
            const response = await fetch(path, {headers: {Accept: "application/json"}})
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

            const data = await response.json()
            data.forEach(model => {
                modelSelect.appendChild(createElement("option", {value: model.id, textContent: model.name}))
            })

            modelSelect.disabled = modelSelect.querySelectorAll("option").length <= 1

            modelSelect.dispatchEvent(new CustomEvent("searchable-select:refresh", {bubbles: true}))
        } catch (error) {
            console.error("Error fetching vehicle models:", error)
        }
    }

    document.body.addEventListener("change", event => {
        if (event.target.matches('select:where([name*="[vehicle_make_id]"], [name*="[vehicle_vehicle_make_id]"])')) {
            updateModelOptions(event.target)
        }
    })
})
